'use client';

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import { cn } from '@morpho-org/ui-v6/utils';
import { Icon, Toggletip, ToggletipContent, ToggletipTrigger } from '@repo/ui';
import { Info } from '@repo/ui/icons';
export interface FilterRowProps {
  label: ReactNode;
  tooltip?: string;
  children: ReactNode;
  className?: string;
}
export function FilterRow(t0) {
  const $ = _c(15);
  const {
    label,
    tooltip,
    children,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("gap-sm flex items-center justify-between", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== label) {
    t2 = <div className="text-2xs text-foreground">{label}</div>;
    $[2] = label;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== tooltip) {
    t3 = tooltip && <Toggletip><ToggletipTrigger asChild={true}><Icon role="button" tabIndex={0} aria-label="More information" icon={<Info />} className="text-muted-foreground hover:text-secondary-foreground" /></ToggletipTrigger><ToggletipContent className="z-60">{tooltip}</ToggletipContent></Toggletip>;
    $[4] = tooltip;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = <div className="gap-2xs flex shrink-0 items-center">{t2}{t3}</div>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== children) {
    t5 = <div className="flex min-w-0 items-center">{children}</div>;
    $[9] = children;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t1 || $[12] !== t4 || $[13] !== t5) {
    t6 = <div className={t1}>{t4}{t5}</div>;
    $[11] = t1;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
}
FilterRow.displayName = 'FilterRow';